import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { api, getToken } from '../../api';
import { QUICK_QUESTIONS } from '../../data/questions';
import QuestionFlow from '../../components/QuestionFlow';

export default function QuickMatch() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const continueToDeep = state?.continueToDeep;
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  if (!getToken()) { navigate('/login'); return null; }

  const handleComplete = async (answers) => {
    setSubmitting(true);
    try {
      if (answers.lifestyle.length) {
        await api.post('/lifestyle/submit', { answers: answers.lifestyle });
      }
      if (answers.intimacy.length) {
        await api.post('/intimacy/submit', { answers: answers.intimacy });
      }
      if (continueToDeep) {
        navigate('/onboarding/deep');
      } else {
        localStorage.setItem('intake_path', 'quick');
        navigate('/onboarding/swipe-faces');
      }
    } catch (err) {
      setError(err.message);
      setSubmitting(false);
    }
  };

  if (submitting) {
    return (
      <div style={{ minHeight: '100vh', background: '#000', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <span className="spinner" />
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ minHeight: '100vh', background: '#000', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 40 }}>
        <div className="error-msg" style={{ textAlign: 'center', marginBottom: 24 }}>{error}</div>
        <button className="btn btn-muted" style={{ maxWidth: 200 }} onClick={() => navigate('/onboarding/swipe-faces')}>
          Continue anyway
        </button>
      </div>
    );
  }

  return <QuestionFlow questions={QUICK_QUESTIONS} onComplete={handleComplete} />;
}
